
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { ActivitiesDetail, HistoryFollowUpLastMile, HistoryFollowUpLastMileEntities, HistoryFollowUpLastMileRequest } from "@/domain/entities/HangingLastMile";
import { debounce } from "lodash";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { Pagination } from "@/domain/entities/Pagination";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";

@Options({
  components: {
    PaginationV3,
  }
})

class TabRiwayatFollowUpLastMile extends Vue {
  isLoading = false;
  errorState = "";
  filterDate = new Date();
  filter = new HistoryFollowUpLastMileRequest();
  historyFollowUpLastMile: HistoryFollowUpLastMile[] = [];
  pagination = new Pagination(1, 10)
  maxDate = new Date();

  get renderedData() {
    return this.historyFollowUpLastMile.flatMap(obj => obj.activities).length;
  }

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryFollowUpLastMileRequest({
      ...this.filter,
      page: 1,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : ""
    });
    startDate && endDate && this.getFilter(this.filter);
  }

  get activityType() {
    return [
      { name: this.$t("dashboard.hanging.allActivities"), value: "" },
      { name: this.$t("dashboard.hanging.followUpCourier"), value: "follow_up_courier" },
      { name: this.$t("dashboard.hanging.followUpPicLastMile"), value: "follow_up_pic_last_mile" },
      { name: this.$t("dashboard.hanging.searchSttWarehouse"), value: "follow_up_warehouse" },
    ];
  }

  activityTypeSelect = false;
  onOpenActivityType(value: boolean) {
    this.activityTypeSelect = value;
  }

  onSelectActivityType(_: string, value: string) {
    this.filter.page = 1;
    this.filter.activityType = value;
    this.onOpenActivityType(false);
    this.getFilter(this.filter);
  }

  async mounted() {
    await this.getHistoryFollowUpLastMile(new HistoryFollowUpLastMileRequest());
  }

  getFilter = debounce((filter: Partial<HistoryFollowUpLastMileRequest>) => {
    this.filter = new HistoryFollowUpLastMileRequest(filter);
    this.getHistoryFollowUpLastMile(this.filter);
  }, 250);

  async getHistoryFollowUpLastMile(params: HistoryFollowUpLastMileRequest) {
    try {
      this.isLoading = true;
      const res = await SttHangingController.getHistoryFollowUpLastMile(params);
      this.historyFollowUpLastMile = res.data;
      this.pagination = res.pagination;
      this.errorState = "";
    } catch (err) {
      this.errorState = "Failed to load data.";
      this.historyFollowUpLastMile = [];
    } finally {
      this.isLoading = false;
    }
  }

  async toPage(page: number) {
    if (page === this.pagination.page) {
      return;
    }
    this.pagination.page = page;
    this.filter = new HistoryFollowUpLastMileRequest({
      ...this.filter,
      page: page
    });
    await this.getHistoryFollowUpLastMile(this.filter);
  }

  mapActivityType(activitie: ActivitiesDetail) {
    const label: any = {
      "follow_up_courier": `${this.$t("dashboard.hanging.followUpCourier")} ${activitie.followUp?.courierName}`,
      "follow_up_pic_last_mile": this.$t("dashboard.hanging.followUpPicLastMile"),
      "follow_up_warehouse": this.$t("dashboard.hanging.searchSttWarehouse"),
    }

    const icon: any = {
      "follow_up_courier": "kurir-hanging",
      "follow_up_pic_last_mile": "ic_pic",
      "follow_up_warehouse": "ic_search_hanging",
    }

    return {
      label: label[activitie.activityType] ?? this.$t("dashboard.hanging.followUpPicLastMile"),
      icon: icon[activitie.activityType] ?? "ic_plane_hanging"
    }
  }

  formatDateToString(date: string) {
    return formatDate(date);
  }
}
export default TabRiwayatFollowUpLastMile;
